import { Select, Option } from './Select';
Select.Option = Option;
export default Select;